<template>
  <div class="toastProp" :style="{'--top': top, '--left': left, '--width': width, '--bottom':bottom}" v-if="value">
    <img class="close" @click="close" src="~images/关闭@2x.png" alt="">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "ToastProp",
  props: {
    top: {
      type: String,
      default: "0",
    },
    left: {
      type: String,
      default: "0",
    },
    value: {
      type: Boolean,
      defalut: false,
    },
    width: {
      type: String,
      defalut: '293px',
    },
    bottom: {
      type: String,
      default: "",
    }
  },
  methods: {
    close() {
      this.$emit("closePop");
    },
  },
};
</script>
<style lang="less">
.toastProp {
  width: var(--width);
  min-height: 253px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(185, 143, 119, 0.4);
  border-radius: 8px;
  position: absolute;
  top: var(--top);
  left: var(--left);
  bottom: var(--bottom);
  padding: 20px 32px;
  box-sizing: border-box;
  z-index: 1;

  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 25px;
    height: 25px;
  }
}
</style>